<template>
  <a
    v-if="url"
    :href="url"
    target="_blank"
  >
    View Activity
  </a>
  <span v-else></span>
</template>

<script setup>
import { computed } from 'vue'

/**
 * @typedef {Object} ActivityResourceLinkCellParams
 * @property {Object} data
 * @property {String} type
 * @property {Number} id
 */
const props = defineProps({
  /** @type {ActivityResourceLinkCellParams} */
  params: {
    type: Object,
    required: true
  }
})

const url = computed(() => {
  if (!props.params.type || !props.params.id) {
    return null
  }

  return route('activity-log', { resource_type: props.params.type, resource_id: props.params.id })
})
</script>
